export default {
    'ERROR-CUSTOMER-ONBOARDING-EMAIL': {
        'EMAIL-INVALID': {
            actionType: 'toast',
            message: {
                fr: "L'adresse e-mail est invalide.",
                en: 'The email address is invalid.',
            },
        },
        'USER-ALREADY-EXISTS': {
            actionType: 'redirect',
            message: {
                fr: "Un compte avec cette adresse e-mail existe déjà.",
                en: 'An account with this email already exists.',
            },
            redirectPath: '/login',
        },
        'CUSTOMER-ONBOARDING-ALREADY-COMPLETED': {
            actionType: 'redirect',
            message: {
                fr: "L'inscription avec cette adresse e-mail est déjà terminée.",
                en: 'The onboarding process with this email is already completed.',
            },
            redirectPath: '/',
        },
    },
    'ERROR-CUSTOMER-ONBOARDING-VERIFY-EMAIL': {
        'CUSTOMER-ONBOARDING-NOT-FOUND': {
            actionType: 'redirect',
            message: {
                fr: "Impossible de vérifier l'e-mail : processus d'inscription introuvable.",
                en: 'Unable to verify email: onboarding process not found.',
            },
            redirectPath: '/onboarding/start',
        },
        'CUSTOMER-ONBOARDING-ALREADY-COMPLETED': {
            actionType: 'redirect',
            message: {
                fr: "L'e-mail a déjà été vérifié et l'inscription est terminée.",
                en: 'The email has already been verified and onboarding is completed.',
            },
            redirectPath: '/',
        },
    },
    'ERROR-CUSTOMER-ONBOARDING-RESEND-EMAIL': {
        'EMAIL-INVALID': {
            actionType: 'toast',
            message: {
                fr: "L'adresse e-mail est invalide.",
                en: 'The email address is invalid.',
            },
        },
        'CUSTOMER-ONBOARDING-NOT-FOUND': {
            actionType: 'toast',
            message: {
                fr: "Aucun processus d'inscription n'est associé à cette adresse e-mail.",
                en: 'No onboarding process is associated with this email address.',
            },
        },
        'CUSTOMER-ONBOARDING-ALREADY-COMPLETED': {
            actionType: 'redirect',
            message: {
                fr: "L'inscription est déjà terminée, aucun e-mail de validation ne sera envoyé.",
                en: 'The onboarding process is already completed, no validation email will be sent.',
            },
            redirectPath: '/',
        },
    },
    'ERROR-CUSTOMER-ONBOARDING-PERSONAL': {
        'CUSTOMER-ONBOARDING-NOT-FOUND': {
            actionType: 'redirect',
            message: {
                fr: "Impossible d'ajouter des informations personnelles : processus d'inscription introuvable.",
                en: 'Unable to add personal information: onboarding process not found.',
            },
            redirectPath: '/onboarding/start',
        },
        'CUSTOMER-ONBOARDING-ALREADY-COMPLETED': {
            actionType: 'redirect',
            message: {
                fr: "L'inscription est déjà terminée, modification impossible.",
                en: 'The onboarding process is already completed, modification is not allowed.',
            },
            redirectPath: '/',
        },
    },
    'ERROR-CUSTOMER-ONBOARDING-COMPANY': {
        'CUSTOMER-ONBOARDING-NOT-FOUND': {
            actionType: 'toast',
            message: {
                fr: "Impossible d'ajouter les informations de l'entreprise : processus d'inscription introuvable.",
                en: 'Unable to add company information: onboarding process not found.',
            },
            redirectPath: '/onboarding/start',
        },
        'CUSTOMER-ONBOARDING-ALREADY-COMPLETED': {
            actionType: 'redirect',
            message: {
                fr: "L'inscription est déjà terminée, modification impossible.",
                en: 'The onboarding process is already completed, modification is not allowed.',
            },
            redirectPath: '/',
        },
        'ORGANIZATION-SUBDOMAIN-ALREADY-EXISTS': {
            actionType: 'toast',
            message: {
                fr: "Ce sous-domaine est déjà utilisé par une autre organisation.",
                en: 'This subdomain is already in use by another organization.',
            },
        },
    },
    'ERROR-CUSTOMER-ONBOARDING-OBJECTIVES': {
        'CUSTOMER-ONBOARDING-NOT-FOUND': {
            actionType: 'redirect',
            message: {
                fr: "Impossible d'ajouter les objectifs : processus d'inscription introuvable.",
                en: 'Unable to add objectives: onboarding process not found.',
            },
            redirectPath: '/onboarding/start',
        },
        'CUSTOMER-ONBOARDING-ALREADY-COMPLETED': {
            actionType: 'redirect',
            message: {
                fr: "L'inscription est déjà terminée, modification impossible.",
                en: 'The onboarding process is already completed, modification is not allowed.',
            },
            redirectPath: '/',
        },
    },
};
